<wbo-report-page #reportPage [formGroup]="reportPage.formGroup">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row [label]="'wbo.report.edit.formation.dateSelection'">
                <wbo-date-range-report-criteria></wbo-date-range-report-criteria>
            </fui-row>
            <fui-row [label]="'wbo.report.edit.options'">
                <fui-rows>
                    <fui-row>
                        <fui-two-columns>
                            <fui-column>
                                <wbo-entity-group-by-report-criteria [showEmployeeOption]="true"
                                                                     [showMemberOption]="true"
                                                                     [showMembershipTypeOption]="true"
                                                                     [showNoGroupOption]="false"
                                                                     [showProductOption]="true"></wbo-entity-group-by-report-criteria>
                            </fui-column>
                            <fui-column>
                                <wbo-entity-sub-group-by-report-criteria></wbo-entity-sub-group-by-report-criteria>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                    <fui-row>
                        <fui-four-columns>
                            <fui-column>
                                <wbo-single-select-edit-control (onSelect)="onSelectLoyaltyType()"
                                                                [(ngModel)]="model.data.loyaltyType"
                                                                [allowClearSelectionOption]="false"
                                                                [formControlName]="'loyaltyType'">
                                    <wbo-select-options>
                                        <wbo-select-option [value]="'ACCRUAL'"
                                                           label="wbo.member-loyalty-report.option.loyaltyType.accrual"></wbo-select-option>
                                        <wbo-select-option [value]="'REDEMPTION'"
                                                           label="wbo.member-loyalty-report.option.loyaltyType.redemption"></wbo-select-option>
                                        <wbo-select-option [value]="'REDEMPTION_LEGACY'"
                                                           label="wbo.member-loyalty-report.option.loyaltyType.redemptionLegacy"></wbo-select-option>
                                    </wbo-select-options>
                                </wbo-single-select-edit-control>
                            </fui-column>
                            <fui-column>
                                <wbo-detail-report-criteria *ngIf="showSummaryOption"></wbo-detail-report-criteria>
                            </fui-column>
                            <fui-column>
                                <wbo-checkbox-edit-control *ngIf="showTops" [(ngModel)]="model.data.topOrderBy"
                                                           [formControlName]="'topOrderBy'"></wbo-checkbox-edit-control>
                            </fui-column>
                            <fui-column>
                                <wbo-numeric-edit-control *ngIf="showTops" [(ngModel)]="model.data.topLimitStmt"
                                                          [formControlName]="'topLimitStmt'"></wbo-numeric-edit-control>
                            </fui-column>
                        </fui-four-columns>
                    </fui-row>
                </fui-rows>
            </fui-row>
            <fui-row>
                <wbo-sellable-report-selection></wbo-sellable-report-selection>
            </fui-row>
            <fui-row *ngIf="showEmployeeSelection">
                <wbo-employee-report-selection></wbo-employee-report-selection>
            </fui-row>
            <fui-row>
                <wbo-member-report-selection></wbo-member-report-selection>
            </fui-row>
            <fui-row>
                <wbo-membership-type-report-selection></wbo-membership-type-report-selection>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-report-page>
